__turbopack_context__.v({
  "empty": "DashboardGrid-module__2xfqoq__empty",
  "root": "DashboardGrid-module__2xfqoq__root",
});
